(function () {
    'use strict';

    angular
        .module('emails')
        .controller('deleteEmailCampaignController', deleteEmailCampaignController);

    deleteEmailCampaignController.$inject = ['$uibModalInstance', 'campaign', 'CampaignsService', 'toastr', 'campaignsList'];

    function deleteEmailCampaignController($uibModalInstance, campaign, CampaignsService, toastr, campaignsList) {
        var vm = this;
        vm.campaign = campaign;
        vm.campaignsList = campaignsList;
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        function activate() {
        }

        function ok () {
            var query = [];
            query['id'] = vm.campaign.id;
            CampaignsService.deleteCampaign(query).then(function(response){
                vm.campaignsList.splice(vm.campaignsList.indexOf(vm.campaign), 1);
                toastr.success('Successfully deleted!');
                $uibModalInstance.close();
            }).catch(function(err) {
                toastr.error('Error:'+err);
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();